import { render } from "./BankAccountForm.vue?vue&type=template&id=478fcfb8"
import script from "./BankAccountForm.vue?vue&type=script&lang=js"
export * from "./BankAccountForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__